import { globalAPIDictionary } from "@core/global/global-country-dictionary";
import { captureException } from "@sentry/react";
import { getIntelUrl } from "@utils/intelUrl";
import axios from "axios";

export const getSaveSearchUrl = (row, url) => {
  const { company_country: country, trade_direction, dataSource, id, is_merged } = row;

  if (!!url && url !== "" && dataSource && trade_direction) {
    if (dataSource.toLowerCase() === "united kingdom") {
      url = url + "?country=uk&type=" + trade_direction.toLowerCase();
    } else if (dataSource.toLowerCase() === "united states" || dataSource.toLowerCase() === "us") {
      url = url + "?country=US&type=" + trade_direction.toLowerCase();
    } else url = url + "?country=" + dataSource.toLowerCase() + "&type=" + trade_direction.toLowerCase();
  } else if (!!url && url !== "" && country && trade_direction) {
    if (country.toLowerCase() === "united kingdom") {
      url = url + "?country=uk&type=" + trade_direction.toLowerCase();
    } else if (country.toLowerCase() === "united states" || country.toLowerCase() === "us") {
      url = url + "?country=US&type=" + trade_direction.toLowerCase();
    } else url = url + "?country=" + country.toLowerCase() + "&type=" + trade_direction.toLowerCase();
  } else if (!!url && url !== "" && country && country.toLowerCase() === "colombia") {
    url = url + "?country=" + country.toUpperCase() + "&type=export";
  } else if (!!url && url !== "" && country && (country.toLowerCase() === "panama" || country.toLowerCase() === "argentina")) {
    url = url + "?country=" + country.toLowerCase() + "&type=export";
  }
  if (is_merged) {
    url = url + `&isMerged=true&mergedID=${id}`;
  }
  if (row && row.company_type) {
    url = url + `&tab=${row.company_type === "export" ? "E" : "I"}`;
  }

  return url;
};

export const navigateToProfileHandler = async (row, type) => {
  try {
    let payload = {
      profile_type: type,
      _id: row.company_id,
    };
    let {
      data: { data },
    } = await axios.post(globalAPIDictionary.getProfileSlugID, { ...payload });
    let url = getIntelUrl() + `ports/${data.slug}/${data.redirection_id}?country=${row?.country || row?.data_source}&type=${row.trade_direction}&profileName=${row?.redirectionKey || row?.redirectionkey}`;
    window.open(url);
  } catch (error) {
    captureException(error);
  }
};
